/* ==========================================================
   SECTION DE VÍDEO NA HOME
   - Injeta uma seção de vídeo logo após o botão "Ver toda la colección"
   - Suporta YouTube, Vimeo ou vídeo .mp4 hospedado no Shopify Files
   - Só aparece na página inicial
   ========================================================== */
(function () {
  'use strict';

  // === CONFIGURAÇÃO ===
  var VIDEO_URL = 'https://cdn.shopify.com/videos/c/o/v/4bab44d6be05452fb09f73e1d05a3101.mp4';

  // Título da seção (vazio = não mostra)
  var SECTION_TITLE = 'Conoce nuestra colección';
  var SECTION_SUBTITLE = ''; // opcional

  // Aspect ratio do vídeo (16/9, 9/16, 1/1, 4/3)
  var VIDEO_RATIO = '16/9';

  // Autoplay (sem som) -> true | false
  var AUTOPLAY = true;

  // ===================================================
  function getVideoType(url) {
    if (!url) return null;
    if (/youtube\.com|youtu\.be/i.test(url)) return 'youtube';
    if (/vimeo\.com/i.test(url)) return 'vimeo';
    if (/\.(mp4|webm|mov)(\?|$)/i.test(url)) return 'mp4';
    return null;
  }

  function getYouTubeId(url) {
    var m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    return m ? m[1] : null;
  }

  function getVimeoId(url) {
    var m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return m ? m[1] : null;
  }

  function buildVideoElement(url) {
    var type = getVideoType(url);
    var autoplayParam = AUTOPLAY ? '1' : '0';
    var muteParam = AUTOPLAY ? '1' : '0';

    if (type === 'youtube') {
      var id = getYouTubeId(url);
      if (!id) return null;
      var src = 'https://www.youtube.com/embed/' + id + '?rel=0&modestbranding=1&autoplay=' + autoplayParam + '&mute=' + muteParam;
      return '<iframe src="' + src + '" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>';
    }
    if (type === 'vimeo') {
      var vid = getVimeoId(url);
      if (!vid) return null;
      var vsrc = 'https://player.vimeo.com/video/' + vid + '?autoplay=' + autoplayParam + '&muted=' + muteParam;
      return '<iframe src="' + vsrc + '" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen loading="lazy"></iframe>';
    }
    if (type === 'mp4') {
      var attrs = 'controls playsinline preload="metadata"';
      if (AUTOPLAY) attrs += ' autoplay muted loop';
      return '<video ' + attrs + ' src="' + url + '"></video>';
    }
    return null;
  }

  function buildPlaceholder() {
    return '<div class="bs-video-placeholder">' +
      '<span style="font-size:48px;line-height:1;margin-bottom:8px;">▶</span>' +
      '<p>Vídeo será exibido aqui</p>' +
      '<small>Edite <strong>assets/custom-home-video.js</strong> e cole a URL na variável <code>VIDEO_URL</code></small>' +
      '</div>';
  }

  function isHomePage() {
    var main = document.getElementById('MainContent');
    if (main && main.dataset.template) {
      if (main.dataset.template === 'index') return true;
    }
    var path = window.location.pathname.replace(/\/$/, '');
    if (path === '' || path === '/') return true;
    return false;
  }

  function injectSection() {
    if (!isHomePage()) return;
    if (document.getElementById('bs-home-video')) return;

    var anchor = document.querySelector('.bs-view-all');
    if (!anchor) {
      var allButtons = document.querySelectorAll('a, button');
      for (var i = 0; i < allButtons.length; i++) {
        var t = (allButtons[i].textContent || '').trim().toLowerCase();
        if (/ver\s+toda/.test(t) || /ver\s+todos/.test(t)) {
          anchor = allButtons[i].closest('.bs-view-all') || allButtons[i].parentElement;
          break;
        }
      }
    }
    if (!anchor) return;

    var content = VIDEO_URL ? buildVideoElement(VIDEO_URL) : null;
    if (!content) content = buildPlaceholder();

    var titleHTML = SECTION_TITLE
      ? '<h2 class="bs-section-title">' + SECTION_TITLE + '</h2>'
      : '';
    var subtitleHTML = SECTION_SUBTITLE
      ? '<p class="bs-video-subtitle">' + SECTION_SUBTITLE + '</p>'
      : '';

    var section = document.createElement('section');
    section.id = 'bs-home-video';
    section.className = 'bs-section bs-home-video-section';
    section.innerHTML =
      '<div class="bs-container">' +
        titleHTML +
        subtitleHTML +
        '<div class="bs-video-wrapper" style="--video-ratio:' + VIDEO_RATIO + ';">' +
          content +
        '</div>' +
      '</div>';

    if (anchor.parentNode) {
      anchor.parentNode.insertBefore(section, anchor.nextSibling);
    }
  }

  function run() { try { injectSection(); } catch (e) {} }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  [300, 1200, 3000].forEach(function (ms) { setTimeout(run, ms); });

  var observer = new MutationObserver(run);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
